import { InvoiceIcmsCstCsosn } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Select, SelectProps } from 'antd';
import { forwardRef } from 'react';

const data = [
  { value: InvoiceIcmsCstCsosn.TRIBUTED_FULLY, label: '00' },
  { value: InvoiceIcmsCstCsosn.TRIBUTED_WITH_ICMS_SUBSTITUTION, label: '10' },
  { value: InvoiceIcmsCstCsosn.REDUCED_BASE, label: '20' },
  { value: InvoiceIcmsCstCsosn.EXEMPT_WITH_ICMS_SUBSTITUTION, label: '30' },
  { value: InvoiceIcmsCstCsosn.EXEMPT, label: '40' },
  { value: InvoiceIcmsCstCsosn.NOT_TRIBUTED, label: '41' },
  { value: InvoiceIcmsCstCsosn.SUSPENDED, label: '50' },
  { value: InvoiceIcmsCstCsosn.DEFERRED, label: '51' },
  { value: InvoiceIcmsCstCsosn.PREVIOUS_ICMS_SUBSTITUTION, label: '60' },
  {
    value: InvoiceIcmsCstCsosn.REDUCED_BASE_WITH_ICMS_SUBSTITUTION,
    label: '70',
  },
  { value: InvoiceIcmsCstCsosn.OTHERS, label: '90' },
];

const TaxeIcmsCstSelect = forwardRef<BaseSelectRef, SelectProps>(
  (props, ref) => {
    return (
      <Select
        {...props}
        showSearch
        optionFilterProp="label"
        ref={ref}
        options={data}
      />
    );
  },
);

export default TaxeIcmsCstSelect;
